import Toastr from "toastr";
import 'toastr/toastr.scss';

const instance = Toastr;
instance.options.progressBar = true;
instance.options.closeButton = true;
instance.options.timeOut = 3000;

export default instance;